// Author lgq
// Date 2022-03-05 15:11:45

import * as model from "@/model/em/statusCollection/EmSicCustomizedDiagramPieceCdpModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSicCustomizedDiagramPieceCdp(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .withMutations({
        setCdpParamConf(state, value) {
            state.entity.cdpParamConf = value
        },
        setCdpProperties(state, value) {
            state.entity.cdpProperties = value
        }
    })
    .buildStore()
